/* eslint-disable no-loop-func */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-console */
import userStorage from './userStorage'

export const httpService = async ({
  method = 'get',
  url,
  endpoint,
  body,
  token,
  aborter,
  setAborter,
  withCredentials = true,
}) => {
  console.log('🚀 ~ withCredentialss:', withCredentials, '  endpoint', endpoint)
  const headers = {
    'Content-type': 'application/json; charset=UTF-8',
  }
  headers.authorization = token || userStorage.getAccessToken()

  const fullUrl = url
    || process.env.REACT_APP_API_DOMAIN
      + (endpoint.startsWith('/') ? '' : '/')
      + endpoint

  // let rawRes
  const retries = 3
  let controller = aborter || new AbortController()
  let timer
  const makeRequest = async () => {
    let remainingTries = retries
    while (remainingTries > 0) {
      try {
        timer = setTimeout(() => {
          remainingTries--
          console.log(
            `aborting... Remaining tries: ${remainingTries} of ${retries}`,
          )
          controller.abort()
          controller = new AbortController() // cannot re-abort a controller
          if (!!aborter && !!setAborter) {
            setAborter(controller)
          }
        }, 15_000)
        // eslint-disable-next-line no-promise-executor-return
        const rawRes = await fetch(fullUrl, {
          method: method.toUpperCase(),
          body: JSON.stringify(body),
          headers,
          credentials: withCredentials ? 'include' : 'omit',
          signal: controller.signal,
        })
        clearTimeout(timer)
        const headerObject = {}
        rawRes.headers.forEach((v, k) => {
          headerObject[k] = v
        })
        let res = null
        try {
          if (headerObject['content-type']?.includes('application/json')) {
            res = await rawRes.json()
          } else {
            res = await rawRes.text()
          }
          res = res === 'null' ? null : res
        } catch (err) {
          console.log(err)
          if (err.name === 'AbortError') {
            return null
          }
          return {
            data: null,
            error: true,
            code: rawRes.status,
            message: 'Ha ocurrido un error',
          }
        }
        return {
          data: res,
          error: !rawRes.ok,
          code: rawRes.status,
          headers: headerObject,
        }
      } catch (err) {
        console.log(err)
        if (err === 'aborted') {
          return null
        }
        if (err.name !== 'AbortError') {
          return {
            data: null,
            error: true,
            code: null,
            message: err.message,
          }
        }
      }
    }
    if (!remainingTries) {
      return {
        data: null,
        error: true,
        code: null,
        message: 'No se ha podido conectar',
      }
    }
  }
  const result = await makeRequest()
  clearTimeout(timer)
  return result
}
